import { useTranslation } from "next-i18next";
import PAButton, { BUTTON_TYPE } from "./buttons/PAButton";

const ViewAllButton = (props: any) => {
  const { t } = useTranslation("common");
  const {
    showButton, isExpanded, expandText = t("View More"), collapseText = t("View Less"), onClick,
  } = props;
  if (!showButton) {
    return null;
  }

  return (
    <div className="row d-flex justify-content-center" style={{ marginTop: "calc(1 * var(--safari-root-font, 10px)) !important" }}>

      <PAButton
        buttonType={BUTTON_TYPE.OUTLINE}
        style={{ width: "auto" }}
        onClick={onClick}
      >
        {!isExpanded ? expandText : collapseText}
      </PAButton>
    </div>
  );
};

export default ViewAllButton;
